<template>
    <Spinner v-if="isLoading" />

</template>
  
<script>
import createHttp from "@/services/http";
import store from "@/store";
import router from "@/router";
import Spinner from "@/components/Spinner.vue"

export default {
    components: { Spinner },
    props: ['id','otype'],
    data() {
        return {
            isLoading: false,
            bankClientId:"250300000",
            bankAmount:0,
            bankOid:"",
            bankOkUrl:"http://localhost:8080/analysisreview/c391a865-2596-4883-98b1-2e17ae7cf59b",
            bankFailUrl:"http://localhost:8080/",
            bankRnd:"",
            bankCurrency: "941",
            bankInstalmentCount: "",
            bankHash: ""  
        }
    }, 
    async mounted() {
        this.isLoading = true;
        debugger;
        
        const http = createHttp(false);
        
        // javim serverju, da je ta analiza plačana
        // console.log(this.id +"////////////////////////////////////////////////////////////////////////////////////////////"); 
        const postData = {
            Oid : this.id,
            Amount: this.amount,
            OkURL: "http://localhost:8080/PaySuccess/" + this.id,
            FailURL: "http://localhost:8080/",
            InstalmentCount: "",
            Rnd: new Date().getTime().toLocaleString(),
        };

        const resultData = await http.post(process.env.VUE_APP_API_FOLDER + "/getPaymentHash", postData);
        if(resultData.status==200){
            // console.log('PREJEL PODATKE OD SERVERJA ZA getPaymentHash !!!!');
            // console.log(resultData.data);
            this.bankHash = resultData.data;         
        }

        this.isLoading = false;
    },     
    methods: {  

    }  
  };
  </script>
  
  <style scoped>

  </style>
  